
import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    closeIconButton: {
        display: 'inline-flex',
        padding: "0 16px 0 10px", 
        color: theme.palette.colors.white
    }
}));